export const menuList = [
  {
    id: 1,
    name: 'Dashboard',
    path: 'dashboard',
    dep2: [
      {
        name: '전체',
        dep3: [{ name: '청오 엔지니어링' }],
      },
    ],
  },
  {
    id: 2,
    name: 'House',
    path: 'house',
    dep2: [
      {
        name: '청오 엔지니어링',
        dep3: [
          {
            name: '센서 데이터',
            path: 'sensor',
            dep4: [
              
            ],
          },
          {
            name: '제어 시스템',
            path: 'control',
          },
          {
            name: '전력 소비량',
            path: 'power',
            dep4: [
              
            ],
          },
        ],
      },
    ],
  },
  {
    id: 3,
    name: 'Container',
    path: 'container',
    dep2: [
      {
        name: '청오 엔지니어링',
        dep3: [
          {
            name: '센서 데이터',
            path: 'sensor',
            dep4: [
              
            ],
          },
          {
            name: '제어 시스템',
            path: 'control',
          },
          {
            name: '전력 소비량',
            path: 'power',
            dep4: [
              
            ],
          },
        ],
      },
    ],
  },
  {
    id: 4,
    name: 'Outdoor',
    path: 'outdoor',
    dep2: [
      {
        name: '청오 엔지니어링',
        dep3: [
        ],
      },
    ],
  },
  {
    id: 5,
    name: 'Energy',
    path: 'energy',
    dep2: [
      {
        name: '청오 엔지니어링',
        dep3: [
          {
            name: '에너지 소비 예측',
          },
        ],
      },
    ],
  },
  {
    id: 6,
    name: 'KMA',
    path: 'kma',
    dep2: [
      {
        name: '청오 엔지니어링',
        dep3: [
          {name: '기상청 강수확률', type: 'POP' },
          {name: '기상청 강수형태', type: 'PTY' },
          {name: '기상청 1시간 강수량', type: 'PCP' },
          {name: '기상청 습도', type: 'REH' },
          {name: '기상청 1시간 신적설', type: 'SNO' },
          {name: '기상청 하늘 상태', type: 'SKY' },
          {name: '기상청 1시간 기온', type: 'TMP' },
          {name: '기상청 일 최저기온', type: 'TMN' },
          {name: '기상청 일 최고기온', type: 'TMX' },
          {name: '기상청 풍속(동서성분)', type: 'UUU' },
          {name: '기상청 풍속(남북성분)', type: 'VVV' },
          {name: '기상청 파고', type: 'WAV' },
          {name: '기상청 풍향', type: 'VEC' },
          {name: '기상청 풍속', type: 'WSD' },
        ],
      },
    ],
  },
];
